import { Helmet } from 'react-helmet'
import VerifyAccountUI from './VerifyAccountUI'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Verify Account UI</title>
    </Helmet>
    <VerifyAccountUI />
  </>
)
export default Wrapper
